(function () {
  function init(root) {
    var scope = root || document;
    var wrap = scope.querySelector('[data-444-notice]');
    if (!wrap) return;
    if (wrap.dataset.showModal !== 'true') return;

    var modal = wrap.querySelector('[data-444-notice-modal]');
    if (!modal) return;
    if (modal.dataset.noticeBound === 'true') return;
    modal.dataset.noticeBound = 'true';

    var key = wrap.dataset.noticeKey;
    var designMode = !!(window.Shopify && window.Shopify.designMode);

    function seen() {
      try {
        return !!window.localStorage.getItem(key);
      } catch (e) {
        return false;
      }
    }

    function remember() {
      if (designMode) return;

      try {
        window.localStorage.setItem(key, '1');
      } catch (e) {}
    }

    function open() {
      modal.hidden = false;

      if (typeof modal.showModal === 'function') {
        modal.showModal();
      } else {
        modal.setAttribute('open', '');
      }

      document.body.classList.add('overflow-hidden');
      wrap.querySelector('[data-444-notice-dialog]')?.focus();
    }

    function cleanup() {
      if (!modal.hidden) modal.hidden = true;
      document.body.classList.remove('overflow-hidden');
      remember();
    }

    function closeModal() {
      if (modal.hasAttribute('open') && typeof modal.close === 'function') {
        modal.close();
      } else {
        modal.removeAttribute('open');
      }
      cleanup();
    }

    modal.addEventListener('close', cleanup);

    wrap.querySelectorAll('[data-444-notice-close]').forEach(function (button) {
      button.addEventListener('click', closeModal);
    });

    modal.addEventListener('click', function (event) {
      if (event.target === modal) closeModal();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (modal.hidden) return;
      closeModal();
    });

    if (designMode || !seen()) open();
  }

  init();
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
